import { render } from "./PCActivityWorker.vue?vue&type=template&id=39c37206"
import script from "./PCActivityWorker.vue?vue&type=script&lang=js"
export * from "./PCActivityWorker.vue?vue&type=script&lang=js"

import "./PCActivityWorker.vue?vue&type=style&index=0&id=39c37206&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__